import { themeQuartz } from 'ag-grid-community';

export const agGridTheme = themeQuartz.withParams({
	cellHorizontalPaddingScale: 0.5,
	columnBorder: false,
	fontFamily: {
		googleFont: 'Open Sans',
	},
	fontSize: 12,
	footerRowBorder: true,
	headerFontSize: 13,
	headerVerticalPaddingScale: 0.7,
	rowVerticalPaddingScale: 0.5,
	spacing: 8,
	wrapperBorder: true,
	wrapperBorderRadius: 8,
});
